import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import { site_url, truck, site_url_img } from "../config.js";
import {  Link } from "react-router-dom";
import { ConnectivityContext } from '../context/ConnectivityContext';
import { cachedGet, cachedPostRead } from '../services/apiCacheService';

function Index() {
    const { effectiveMode } = React.useContext(ConnectivityContext);
    const queryParams = new URLSearchParams(useLocation().search);
    const id = queryParams.get('id');
    const fromDate = queryParams.get('fromDate');
    const toDate = queryParams.get('toDate');
    const w_type = queryParams.get('w_type');
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    const shopdetails = async () => {
        try {
            let response;
            if(w_type == 1){
                const data={
                    fromdate:fromDate,
                    todate:toDate,
                    cate_id:id
                  }
                 const responseData = await cachedPostRead(site_url + '/view_collection_data_route_shops', data, {}, effectiveMode === 'offline');
                 response = { data: responseData };

            }else{
                 const responseData = await cachedGet(site_url + '/shoplist/' + id, {}, effectiveMode === 'offline');
                 response = { data: responseData };

            }
            if (response.data.status === 'success') {
                setData(response.data.shops);
            }
        } catch (error) {
            console.error("Error fetching shop details", error);
        }
    };

    useEffect(() => {
        shopdetails();
    }, [id]);

    // Filter shops based on search query
    const filteredShops = data.filter(shop =>
        shop.shop_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        shop.phone.includes(searchQuery) ||
        shop.address.toLowerCase().includes(searchQuery.toLowerCase()) ||
        shop.city.toLowerCase().includes(searchQuery.toLowerCase()) ||
        shop.state.toLowerCase().includes(searchQuery.toLowerCase()) ||
        shop.pincode.includes(searchQuery)
    );
    const formatINR = (amount) => {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          maximumFractionDigits: 2
        }).format(amount);
      };
    return (
        <div id="appCapsule">
            <div className="section mt-4">
                <div className="section-heading">
                    <h2 className="title">Shops</h2>
                </div>

                {/* Search Box */}
                <div className="input-group mb-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search Shops..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>

                <div className="transactions">
                    {filteredShops.map((item) => (
                    <div className="item" key={item.id}>
                            <div className="detail">
                                {item.shop_img ? (
                                    <img
                                        src={site_url_img + '/' + item.shop_img}
                                        alt="img"
                                        className="image-block imaged w48"
                                    />
                                ) : (
                                    <img
                                        src={truck}
                                        alt="img"
                                        className="image-block imaged w48"
                                    />
                                )}
                                <div>
                                    <strong>{item.shop_name}</strong>
                                    <strong>{item.shop_name_tamil}</strong>
                                    <div className="d-flex align-items-center gap-2 mb-2">
                                        {/* <span className="fw-bold">{item.phone} / {item.whatsapp_number}</span> */}
                                        <div className="d-flex gap-1">
                                            <button 
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={() => window.open(`tel:${item.phone}`, '_self')}
                                                title="Call"
                                            > 📞 {item.phone}
                                            </button>
                                            <button 
                                                className="btn btn-sm btn-outline-success"
                                                onClick={() => window.open(`tel:${item.whatsapp_number}`, '_self')}
                                                title="WhatsApp"
                                            > 📞
                                                {item.whatsapp_number}
                                            </button>
                                        </div>
                                    </div>
                                    <p>{item.address} {item.city} {item.state} - {item.pincode}</p>
                                    <h6>Previous Amount: {formatINR(item?.prev_pending_amount)}</h6>
                                    <h6>Current Bill Amount: {formatINR(item?.current_date_bill)}</h6>
                                    <h5 className='text-danger mt-1'>Bln Amount: {formatINR(item?.pending_amount)}</h5>
                                    <div className='row mt-2'>
                                        <div className='col-6'>
                                        <Link to={`/Paymentshop?id=${item.id}&shop_name=${encodeURIComponent(item.shop_name)}`} >
                                              <button className='btn btn-danger'>Payment</button>
                                              </Link>
                                        </div>
                                        <div className='col-6'>
                                        <Link to={`/Bill?id=${item.id}&name=${encodeURIComponent(item.shop_name_tamil+' / '+item.shop_name)}`}>

                                              <button className='btn btn-success'>New Bill</button>
                                              </Link>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Sidebar />
            <Footer />
        </div>
    );
}

export default Index;
